<!--抽奖按钮-->
<template>
  <div
    :class="[isPc ? 'lottery-draw-btn-contain-pc' : 'lottery-draw-btn-contain']"
    v-show="isShow && canShow"
    @click="btnClick"
  >
    <van-popover
      v-model="showPopover"
      theme="dark"
      :placement="isPc?'bottom':'top'"
      :close-on-click-action="false"
      :close-on-click-outside="false"
    >
      <div :class="[isPc?'popover-tip-pc':'popover-tip']">{{content.drawNoPerfect}}<br>{{content.drawGoPerfect}}</div>
      <template #reference>
        <van-image
          width="0.44rem"
          height="0.44rem"
          :src="require('@/assets/imgs/draw-icon.png')"
        />
      </template>
    </van-popover>
    <div class="draw-tip">
      <div
        v-if="!showPopover && countDownTime <= 0"
        class="draw-btn"
      >{{content.draw}}</div>
      <div
        v-if="!showPopover && countDownTime > 0"
        class="tip-countdown"
      >
        <van-count-down
          :time="countDownTime"
          @finish="countDownFinish"
        >
          <template #default="timeData">
            <div class="block-p">
              <div class="block">{{ (timeData.days * 24 + timeData.hours) | addZero }}</div>
            </div>
            <div class="colon">:</div>
            <div class="block-p">
              <div class="block">{{ timeData.minutes | addZero }}</div>
            </div>
            <div class="colon">:</div>
            <div class="block-p">
              <div class="block">{{ timeData.seconds | addZero }}</div>
            </div>
          </template>
        </van-count-down>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    canShow: { // 是否可展示，防止抽奖按钮显示在表情面板上方
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShow: false, // 是否显示抽奖
      countDownTime: 0, // 倒计时时长
      innerCountDown: null, // 倒计时函数
      needLogin: false, // 是否需要登录
      needPerfect: false, // 是否需要完善资料
      needCountdown: false, // 是否需要倒计时显示
      startTime: '', // 开始时间
      endTime: '', // 结束时间
    }
  },
  computed: {
    showPopover() {
      // 需要登录或完善资料都需要提示
      return this.needLogin || this.needPerfect
    },
    content() {
      return this.$store.state.content
    },
    ...mapState(['isPc'])
  },
  filters: {
    addZero(val) {
      return val > 9 ? val : ('0' + val)
    }
  },
  methods: {
    show(obj) {
      this.needLogin = obj.needLogin
      this.needPerfect = obj.needPerfect
      this.needCountdown = obj.needCountdown
      this.startTime = obj.startTime
      this.endTime = obj.endTime
      // 先清空之前倒计时再重新倒计时
      if (this.innerCountDown != null) {
        clearTimeout(this.innerCountDown)
        this.innerCountDown = null
      }
      // 有开始时间且已经登录且完善的用户可以倒计时
      if (this.startTime != '' && !this.showPopover) {
        // 还没到时间
        if (new Date(this.startTime.replace(/-/g, '\/')).getTime() - new Date() > 0) {
          // 如果要显示倒计时且未到开始时间，则显示倒计时
          if (this.needCountdown) {
            this.countDownTime = new Date(this.startTime.replace(/-/g, '\/')).getTime() - new Date()
          } else {
            this.countDownTime = 0
            // 内部做倒计时
            this.innerCountDownTime()
          }
        } else if (new Date(this.startTime.replace(/-/g, '\/')).getTime() - new Date() <= 0) {
          // 已经在开始时间后了
          if (this.endTime != '' && new Date(this.endTime.replace(/-/g, '\/')).getTime() - new Date() > 0) {
            // 还没到结束时间，弹出抽奖页面
            this.$emit('draw', 500)
          }
        }
      }
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    btnClick() {
      if (this.needLogin) {
        // 游客需要登录
        this.$emit('login')
      } else if (this.needPerfect) {
        // 需要完善资料
        this.$emit('register')
      } else {
        // 弹出抽奖页面
        this.$emit('draw', 0)
      }
    },
    // 自动倒计时结束
    countDownFinish() {
      this.countDownTime = 0
      this.$emit('draw', 1000)
    },
    // 还未到开始时间但不显示倒计时，则前端内部倒计时
    innerCountDownTime() {
      let willStart = new Date(this.startTime.replace(/-/g, '\/')).getTime() - new Date()
      if (willStart > 0) {
        this.innerCountDown = setTimeout(() => {
          this.innerCountDownTime()
        }, 1000)
      } else {
        this.countDownTime = 0
        this.innerCountDown = null
        this.$emit('draw', 1000)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.popover-tip-pc {
  font-size: 0.13rem;
  padding: 0.05rem 0.06rem;
  text-align: center;
}
.popover-tip {
  font-size: 0.09rem;
  padding: 0.05rem 0.06rem;
  text-align: center;
}
.lottery-draw-btn-contain-pc{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 0.8rem;
  text-align: center;
  cursor: pointer;
  .van-popover__wrapper{
    display: flex;
  }
  .draw-tip {
    margin-top: -0.05rem;
    background: linear-gradient(0deg, #ffc600, #fff945);
    box-shadow: 0rem 0.03rem 0rem 0rem rgba(255, 148, 8, 0.8);
    border-radius: 10px;
    z-index: 1;
    .draw-btn {
      font-weight: bold;
      color: #ff3c17;
      font-size: 0.1rem;
      padding: 0.03rem 0.19rem 0.02rem;
      white-space: nowrap;
    }
    .tip-countdown {
      padding: 0.03rem 0.14rem 0.02rem;
      .van-count-down {
        font-size: 0.11rem;
        color: #fff;
        display: flex;
        background-color: transparent;
        // padding: 0.02rem 0.04rem 0.04rem;
        line-height: 0.2rem;
        border-radius: 2px;
        .block-p {
          position: relative;
          .block {
            background-color: #ff3c17;
            height: 0.2rem;
            line-height: 0.22rem;
            padding: 0 0.02rem;
            border-radius: 2px;
          }
          .unit {
            position: absolute;
            right: 0;
            bottom: -0.12rem;
            color: #383838;
            text-align: right;
            transform: scale(0.6);
          }
        }
        .colon {
          color: #fff;
          padding: 0 0.02rem;
        }
      }
    }
  }
}
.lottery-draw-btn-contain {
  position: absolute;
  right: 0.18rem;
  bottom: calc(calc(env(safe-area-inset-bottom)) + 0.75rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 0.8rem;
  text-align: center;
  cursor: pointer;
  z-index: 1700;
  .van-popover__wrapper{
    display: flex;
  }
  .draw-tip {
    margin-top: 0.05rem;
    background: linear-gradient(0deg, #ffc600, #fff945);
    box-shadow: 0rem 0.03rem 0rem 0rem rgba(255, 148, 8, 0.8);
    border-radius: 10px;
    .draw-btn {
      font-weight: bold;
      color: #ff3c17;
      font-size: 0.1rem;
      padding: 0.03rem 0.19rem 0.02rem;
      white-space: nowrap;
    }
    .tip-countdown {
      padding: 0.03rem 0.14rem 0.02rem;
      .van-count-down {
        font-size: 0.11rem;
        color: #fff;
        display: flex;
        background-color: transparent;
        // padding: 0.02rem 0.04rem 0.04rem;
        line-height: 0.2rem;
        border-radius: 2px;
        .block-p {
          position: relative;
          .block {
            background-color: #ff3c17;
            height: 0.2rem;
            line-height: 0.22rem;
            padding: 0 0.02rem;
            border-radius: 2px;
          }
          .unit {
            position: absolute;
            right: 0;
            bottom: -0.12rem;
            color: #383838;
            text-align: right;
            transform: scale(0.6);
          }
        }
        .colon {
          color: #fff;
          padding: 0 0.02rem;
        }
      }
    }
  }
}
</style>